import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenericKeysModel } from '../../../../shared/models';

@Component({
    selector: 'app-header-generic',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderGenericComponent implements OnInit {
    @Input() isLoadingContent;
    @Input() backgroundHeader;
    @Input() currentGenericKey;
    @Input() isBrowser: boolean;

    @Output() KeyPressed: EventEmitter<any> = new EventEmitter<any>();

    genericKeyLPG = GenericKeysModel.LPG;

    constructor() {}

    ngOnInit(): void {}

    onKeyPressed(ev: any) {
        this.KeyPressed.emit(ev);
    }
}
